const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/components/AppBar/TextArea/styles.ts';
import * as React from 'react';
import { css } from '@emotion/css';
import { theme } from 'App/utils/clientSetupManager';

export const textAreaStyle = css`
    flex: 1;
    padding-left: ${theme.spacing(2)};
    transform-origin: bottom left;
`;

export const primaryTextStyle: React.CSSProperties = {
    lineHeight: 1,
};

export const secondaryTextStyle: React.CSSProperties = {
    lineHeight: 1,
    marginTop: 4,
};
